export interface RootState {
    isLoading: boolean | null;
    isLoadingDetailStat: boolean | null;
}

export interface SelectItem {
    text: string
    value: string | number
}

export enum MsgTransports {
    SMS='SMS',
    CALL='Call',
    EMAIL='Email',
    PUSH='Push',
    VIBER = 'Viber',
    WHATSAPP = 'WhatsApp',
    CUSTOM = 'Custom',
    MAILNOTIFY = 'Mail Notify',
    TELEGRAM_OTP = 'Telegram OTP',
}

export const transportsMap: Map<MsgTransports, number> = new Map([
  [MsgTransports.SMS, 1],
  [MsgTransports.CALL, 2],
  [MsgTransports.EMAIL, 3],
  [MsgTransports.PUSH, 4],
  [MsgTransports.VIBER, 6],
  [MsgTransports.WHATSAPP, 7],
  [MsgTransports.TELEGRAM_OTP, 8],
])